import { useContext } from 'react';
import { HookFormContext } from '@/context/HookFormContext';

export const useHookFormController = () => {
    const { controller } = useContext(HookFormContext);

    if (!controller) {
        throw new Error('Context not found. Please use <HookFormProvider /> for your form.');
    }

    return controller;
};
